<template>
  <div style="padding:15px;" class="containerTable">
    <vxe-toolbar
      id="toolbarId_fs23"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button
          v-if="getLimit('userInvoiceStatistics_search_button')"
          @click="funcFilter"
          >查询</el-button
        >
        <!-- <el-button @click="funcAdd">新增</el-button> -->
        <el-date-picker
          v-model="listQuery.gmtCreatedRange"
          type="daterange"
          value-format="yyyy-MM-dd"
          :picker-options="optionsPicker"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="value => changeDate(value, 'gmtCreated')"
        />
        <el-button
          v-if="getLimit('userInvoiceStatistics_export_button')"
          @click="funcExport"
          >导出</el-button
        >
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      resizable
      border
      :loading="loading"
      highlight-current-row
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="80%"
      show-footer
      :footer-method="footerMethod"
      :data="tableData"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left" />
      <vxe-table-column>
        <vxe-table-column
          field="branchCode"
          title="承运主体"
          :formatter="formatterBranch"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.branchCode"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in branchList"
              :key="item.code"
              :label="item.groupName"
              :value="item.code"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="开票用户名称"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入开票用户名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="开票用户电话"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入开票用户电话"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdYearMonth"
          title="开票年月"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.createdYearMonth"
            clearable
            type="month"
            value-format="yyyy-MM"
            placeholder="请输入开票年月"
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="address"
          title="地址"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.address"
            placeholder="请输入地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="invoiceTitle"
          title="发票抬头"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.invoiceTitle"
            placeholder="请输入发票抬头"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="taxRegistrationNumber"
          title="税务登记证号"
          min-width="150"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.taxRegistrationNumber"
            placeholder="请输入税务登记证号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="issueType"
          title="开票类型"
          :formatter="formatterIssueType"
          min-width="100"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.issueType"
            placeholder="请选择"
            clearable
          >
            <el-option label="个人" value="0" />
            <el-option label="企业" value="1" />
          </el-select>
        </template>
      </vxe-table-column>
      <vxe-table-column
        field="orderAmountSum"
        title="含税运费"
        min-width="100"
        sortable
      />
      <vxe-table-column
        field="invoiceAmountSum"
        title="运费税额"
        min-width="100"
        sortable
      />
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import request from "@/utils/request";

export default {
  name: "Index",
  data() {
    return {
      tableData: [],
      exportObj: {
        exportUrl: "/ntocc-tms-api/statistics/exportUserInvoiceStatistics", //导出接口
        name: "运单开票"
      },
      listQuery: {
        name: "",
        phone: "",
        invoiceAmountSum: "",
        receiverCode: "",
        orderAmountSum: "",
        address: "",
        invoiceTitle: "",
        taxRegistrationNumber: "",
        issueType: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      },
      issueTypeOptions: [
        { label: "个人", value: 0 },
        { label: "企业", value: 1 }
      ],
      // 机构列表
      branchList: this.$store.state.components.branchList
    };
  },
  created() {
    this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        request({
          url: "ntocc-tms-api/statistics/userInvoiceStatistics",
          method: "get",
          params: this.listQuery
        }).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 翻译机构
    formatterBranch({ cellValue }) {
      const item = this.branchList.find(item => item.code === cellValue);
      return item ? item.groupName : "";
    },
    formatterIssueType({ cellValue }) {
      const item = this.issueTypeOptions.find(item => item.value === cellValue);
      return item ? item.label : "";
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (
            ["invoiceAmountSum", "orderAmountSum"].includes(column.property)
          ) {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    }
  }
};
</script>

<style scoped></style>
